angular
  .module("myApp")
  .directive("zinatniskaisGrads", () => ({
    restrict: "E",
    replace: true,
    templateUrl: "templates/grads.directive.html",
    scope: {
      dto: "=ngModel",
      editMode: "=",
    },
    controller: "ZinatniskaisGradsController as ctl",
  }))
  .controller("ZinatniskaisGradsController", function (Codifiers, $scope) {
    this.tmp = undefined
    this.used = {}
    this.assoc = {}
    this.gradi = []

    Codifiers.kla.$promise.then(() => {
      this.gradi = Codifiers.kla.zinatniskais_grads

      this.gradi.forEach((n) => {
        this.assoc[n.id] = n.nosaukums
      })
    })

    this.removeGrads = (d) => {
      const idx = $scope.dto.indexOf(d)

      if (idx !== -1) {
        $scope.dto.splice(idx, 1)
      }

      this.update_used()
    }

    this.addGrads = (zin_grads_id) => {
      if (!zin_grads_id) return

      const exists = $scope.dto.some((e) => e.zin_grads_id === zin_grads_id)

      if (!exists) {
        $scope.dto.push({ zin_grads_id })
        this.update_used()
      }
    }

    this.addGradsFromSelect = () => {
      this.addGrads(this.tmp)
      this.tmp = undefined
    }

    this.update_used = () => {
      Object.keys(this.used).forEach((k) => {
        this.used[k] = false
      })

      $scope.dto.forEach((e) => {
        this.used[e.zin_grads_id] = true
      })
    }
  })
